import { FC } from "react";

import { CrudEditContextWrapper } from "@ryde/controls";
import {
  ICourseDto,
  ICourseEditDrawerProps,
  IInjectedDrawerProps,
} from "@ryde/shared";

import {
  CourseEditContent,
  CoursesEditFormTagWrapper,
} from "../../../layout-edit";

export const CourseEditFormDrawer: FC<
  ICourseEditDrawerProps & IInjectedDrawerProps
> = ({
  resolveFn,
  onCloseDrawer,
  mode,
  id,
  idCopyFrom,
  drawerNumber,
  hasPrefilledDraft,
}) => {
  return (
    <CrudEditContextWrapper<ICourseDto>
      entity="course"
      mode={mode}
      id={id}
      idCopyFrom={idCopyFrom}
    >
      <CoursesEditFormTagWrapper>
        <CourseEditContent
          resolveFn={resolveFn}
          onCloseDrawer={onCloseDrawer}
          drawerNumber={drawerNumber}
          hasPrefilledDraft={hasPrefilledDraft}
        />
      </CoursesEditFormTagWrapper>
    </CrudEditContextWrapper>
  );
};
